export default {
  CASES_TABLE: {
    ERROR_MESSAGES: {
      ERROR_WHILE_LOADING_CASES: 'Valami hiba történt az ügyek betöltésekor!',
      ERROR_WHILE_LOADING_PARTNERS: 'Valami hiba történt a partnerek betöltésekor!',
      ERROR_WHILE_LOADING_STATES: 'Valami hiba történt a státuszok betöltésekor!',
    },
    FILTERS: {
      APPLY: 'Szűrés',
      STAGE_LABEL: 'Fő státusz',
      CLIENT: {
        LABEL: 'Hitelező',
        PLACEHOLDER: 'Kezdjen el gépelni...',
      },
      CASE_ID: {
        LABEL: 'Ügyazonosító',
        PLACEHOLDER: 'Kezdjen el gépelni...'
      },
      DEBTOR_NAME: {
        LABEL: 'Adós',
        PLACEHOLDER: 'Kezdjen el gépelni...'
      },
      PARTNER: {
        LABEL: 'Partner',
        PLACEHOLDER: 'Kezdjen el gépelni...',
      },
      PRODUCT: {
        LABEL: 'Termék',
        PLACEHOLDER: 'Válasszon terméket...',
        NOTICE: 'Fizetési felszólítás',
        DEMAND_LETTER: 'Ügyvédi levél',
        HARD_1: 'Fizetési meghagyás',
        HARD_2: 'Fizetési meghagyás - végrehajtás',
      },
      STAGE: {
        DRAFT: 'Piszkozat',
        ONGOING: 'Folyamatban',
        CLOSED: 'Lezárva',
      },
      STATE: {
        LABEL: 'Státusz',
        PLACEHOLDER: 'Kezdjen el gépelni...',
      },
      STARTED_AT: {
        LABEL: 'Indítás dátuma',
        MIN_LABEL: 'Indítás dátuma (tól)',
        MAX_LABEL: 'Indítás dátuma (ig)',
      },
    },
    TABLE_INFO: {
      CLOSED: 'Lezárt ügyek',
      CLOSED_INFO:
        'Ezek az ügyek, amik vagy sikeresen kifizetésre kerültek, vagy egyéb okból lettek leállítva.',
      DRAFT: 'Piszkozatok',
      DRAFT_INFO:
        'Ezek az ügyek, amiket félbehagytál. Ha egy Számlázz.hu-s számláról az Ügyvédi és jogi megoldások linkre kattintva jöttél ide, akkor minden ilyen átkattintással keletkezett egy piszkozat.',
      ONGOING: 'Nyitott ügyek',
      ONGOING_INFO:
        'Ezek az ügyek, amik sikeresen elindultak, és jelenleg is futnak. Ha bármelyikkel teendőd lenne, akkor arról emailben is értesítünk majd.',
    },
    HEADERS: {
      CASE_ID: 'Ügyazonosító',
      REMAINING_CLAIMS: 'Fennálló követelés',
      ORIGINAL_CLAIMS: 'Eredeti követelés',
      PARTIES: 'Felek',
      STATE: 'Státusz',
      STARTED_AT: 'Indítva',
      LAST_EVENT: 'Utolsó esemény',
      DEADLINE: 'Határidő',
    },
    CASE_ACTIONS: {
      DELETE: 'Ügy törlése',
      EDIT: 'Ügy szerkesztése',
      NO_ACTIONS: 'Nincs elérhető esemény',
    },
    CASE_DETAILS: {
      DETAILS_LABEL: 'Részletek',
      EVENTS_LABEL: 'Események',
    },
    NO_CASES: {
      TITLE: 'Nem található ügy a megadott feltételekkel',
    },
    MORE_CURRENCIES: '+{{count}} további',
  },
};
